import React from 'react';
import { SVGProps } from 'react';

export const SvgGeoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        viewBox="0 0 16 16"
        {...props}
    >
        <path
            fill="#8D969F"
            fillRule="evenodd"
            d="M4.874 1.56c-1.608.532-2.535 1.578-2.756 3.27-.1.77-.148 1.546-.098 2.323.089 1.405.599 2.751 1.464 3.861.136.175.288.346.59.688l1.01 1.14c1.155 1.302 1.732 1.953 2.445 2.107.31.068.632.068.942 0 .713-.154 1.29-.805 2.444-2.107l1.01-1.14c.303-.342.455-.513.591-.688a7.004 7.004 0 0 0 1.464-3.86c.05-.778.002-1.554-.098-2.324-.22-1.692-1.149-2.738-2.756-3.27C10.211 1.259 9.106 1 8 1c-1.106 0-2.211.258-3.126.56Zm2.794 3.286a4.494 4.494 0 0 1 .665 0l.046.004c.346.025.657.048.94.33.283.284.306.595.331.941l.004.047a4.494 4.494 0 0 1 0 .664l-.004.047c-.025.346-.048.657-.33.94-.284.283-.595.306-.941.331l-.046.004a4.5 4.5 0 0 1-.665 0l-.046-.004c-.347-.025-.658-.048-.941-.33-.283-.284-.306-.595-.331-.941l-.004-.047a4.5 4.5 0 0 1 0-.664l.004-.047c.025-.346.048-.657.33-.94.284-.283.595-.306.942-.331l.046-.004Z"
            clipRule="evenodd"
        />
    </svg>
);
